export const boolToNumeric = (v: boolean | null): 0 | 1 | undefined => {
  return v === null ? undefined : v ? 1 : undefined;
};
